if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// thumbnail
var product_slider_thumbs = new Swiper(
  ".section-main-products .product-thumbnail-slider",
  {
    slidesPerView: 5,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1199: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  }
);

// Main slider
var inv__slider = document.querySelector(
  ".section-main-products .product__slider-container"
);
if (inv__slider) {
  var inv_product_slider = new Swiper(
    ".section-main-products .product__slider-container",
    {
      spaceBetween: 10,
      thumbs: {
        swiper: product_slider_thumbs,
      },
      navigation: {
        nextEl: ".swiper-button-next-for",
        prevEl: ".swiper-button-prev-for",
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
      },
    }
  );

  // Listen for slide change events on the main slider
  inv_product_slider.on("slideChange", function () {
    var activeIndex = inv_product_slider.activeIndex;
    product_slider_thumbs.slides.removeClass("swiper-slide-active");
    product_slider_thumbs.slides
      .eq(activeIndex)
      .addClass("swiper-slide-active");
  });

  // Listen for click events on thumbnails
  product_slider_thumbs.on("click", function () {
    var clickedIndex = product_slider_thumbs.clickedIndex;
    // console.log(clickedIndex)
    inv_product_slider.slideTo(clickedIndex);
  });
}

// variant radio change to change image
var variantRadioButtons = document.querySelectorAll(
  ".section-main-products .variantRadioButton"
);
if (variantRadioButtons) {
  variantRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      const radioDataIndex = radioButton.getAttribute("data-index");
      updateSwiperSlide(radioDataIndex);
    });
  });

  function updateSwiperSlide(variantIndex) {
    var mediaItems = document.querySelectorAll(
      ".section-main-products .product__media-item"
    );

    mediaItems.forEach(function (mediaItem) {
      var altMedia = mediaItem.getAttribute("data-media-attr");
      // console.log(altMedia, variantIndex)
      if (altMedia == variantIndex) {
        var swiperSlideIndex = mediaItem.getAttribute(
          "data-swiper-slide-index"
        );
        inv_product_slider.slideTo(swiperSlideIndex);
      }
    });
  }
}

// Bundle Code
$(document).ready(function () {
  $(".pdp_pair-content").click(function () {
    var $checkbox = $(this).prev('input[type="checkbox"]');
    setTimeout(function () {
      var input_checked = $checkbox.prop("checked");
      if (input_checked == true) {
        $(".bundle-form__atc").addClass("hidden");
        $(".bundle-form__submit").removeClass("hidden");
      } else {
        $(".bundle-form__atc").removeClass("hidden");
        $(".bundle-form__submit").addClass("hidden");
      }

      var valsText = $(
        ".loop-selected-selling-plan-group #loop-price-one-time"
      ).text();
      var vals = parseFloat(valsText.replace(/[^\d.-]/g, ""));
      var bundleText = $(".pdp_pair-content .bundle-price-reg").text();
      var bundle_val = parseFloat(bundleText.replace(/[^\d.-]/g, ""));
      var sum = vals + bundle_val;

      $(".bundle-form__submit .btn_price").text("- $" + sum);

      var vals = $(".loop-selected-selling-plan-group label").text();
      if (vals == "One-time Purchase") {
        var valsText = $(
          ".loop-selected-selling-plan-group #loop-price-one-time"
        ).text();
        var vals = parseFloat(valsText.replace(/[^\d.-]/g, ""));
        var bundleText = $(".pdp_pair-content .bundle-price-reg").text();
        var bundle_val = parseFloat(bundleText.replace(/[^\d.-]/g, ""));
        var sum = vals + bundle_val;

        $(".bundle-form__submit .btn_price").text("- $" + sum);
      } else {
        var valsText = $(
          ".loop-selected-selling-plan-group .loop-subscription-group-price-amount"
        ).text();
        var vals = parseFloat(valsText.replace(/[^\d.-]/g, ""));
        var bundleText = $(".pdp_pair-content .bundle-price-reg").text();
        var bundle_val = parseFloat(bundleText.replace(/[^\d.-]/g, ""));
        var sum = vals + bundle_val;

        $(".bundle-form__submit .btn_price").text("- $" + sum);
      }
    }, 200);
  });

  $(".bundle-form__submit").click(function (event) {
    event.preventDefault(); // Prevent default form submission

    var variantId = $(".bundle-product-checkbox-block input:checked").attr(
      "data-bundle-variant-id"
    );
    var pdp_variant_id = $(".product-variant-id").val();
    var pdp_qty = $(".qty_add_cart .quantity__input").val();
    var selling_id = $('input[name="selling_plan"]').val();

    const extraItem = {
      items: [
        {
          id: pdp_variant_id,
          quantity: pdp_qty,
          selling_plan: selling_id,
        },
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    bundle_changeVariant("/cart/add.js", extraItem);
  });
});

function bundle_changeVariant(url, sendData) {
  fetch(url, {
    body: JSON.stringify(sendData),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    redirect: "follow",
    referrerPolicy: "no-referrer",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // Update cart drawer content
      $.ajax({
        url: "/?section_id=cart-drawer",
        type: "GET",
        dataType: "html",
        success: function (carthtml) {
          $(".cart-drawer").html($(carthtml).find(".cart-drawer").eq(0).html());
          $(".cart-drawer").load(location.href + " #CartDrawer");
          $("cart-drawer").removeClass("is-empty");
          $("cart-drawer").addClass("active");
          load_cart();
        },
        error: function (xhr, status, error) {
          console.error("Error fetching cart drawer content:", error);
        },
      });
    })
    .catch((error) => {
      console.error("Error adding item to cart:", error);
    });
}

function load_cart() {
  const url = "/cart.js";
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      var cart_count = data.item_count;
      $(".cart-count-bubble span").text(cart_count > 0 ? cart_count : "0");
      $(".cart-count-bubble").removeClass("hidden");
    })
    .catch((error) => {
      console.error("Error loading cart:", error);
    });
}

const var_url = document
  .querySelector(".product__info-container")
  .getAttribute("data-url");

if (var_url == "/products/mascara-offer" || var_url == "/products/mascara") {
  var atc_click = document.querySelector(".main_prod_save_product");
  /*var remove_click = document.querySelector(".cart-remove-button");*/
  atc_click.addEventListener("click", function () {
    setTimeout(function () {
      var product_slider_thumbs_1 = new Swiper(
        ".section-main-products .product-thumbnail-slider",
        {
          slidesPerView: 5,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          breakpoints: {
            749: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            991: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1199: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
          },
        }
      );

      // Main slider
      var inv__slider_1 = document.querySelector(
        ".section-main-products .product__slider-container"
      );
      if (inv__slider_1) {
        var inv_product_slider_1 = new Swiper(
          ".section-main-products .product__slider-container",
          {
            spaceBetween: 10,
            thumbs: {
              swiper: product_slider_thumbs_1,
            },
            navigation: {
              nextEl: ".swiper-button-next-for",
              prevEl: ".swiper-button-prev-for",
            },
            breakpoints: {
              750: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              320: {
                slidesPerView: 1.2,
                spaceBetween: 10,
              },
            },
          }
        );

        // Listen for slide change events on the main slider
        inv_product_slider_1.on("slideChange", function () {
          var activeIndex_1 = inv_product_slider_1.activeIndex;
          product_slider_thumbs_1.slides.removeClass("swiper-slide-active");
          product_slider_thumbs_1.slides
            .eq(activeIndex)
            .addClass("swiper-slide-active");
        });

        // Listen for click events on thumbnails
        product_slider_thumbs_1.on("click", function () {
          var clickedIndex_1 = product_slider_thumbs_1.clickedIndex;
          inv_product_slider_1.slideTo(clickedIndex_1);
        });
      }

      // variant radio change to change image
      var variantRadioButtons_1 = document.querySelectorAll(
        ".section-main-products .variantRadioButton"
      );
      if (variantRadioButtons_1) {
        variantRadioButtons_1.forEach(function (radioButton_1) {
          radioButton_1.addEventListener("change", function () {
            const radioDataIndex_1 = radioButton_1.getAttribute("data-index");
            updateSwiperSlide_1(radioDataIndex_1);
          });
        });

        function updateSwiperSlide_1(variantIndex_1) {
          var mediaItems_1 = document.querySelectorAll(
            ".section-main-products .product__media-item"
          );

          mediaItems_1.forEach(function (mediaItem_1) {
            var altMedia_1 = mediaItem_1.getAttribute("data-media-attr");
            // console.log(altMedia, variantIndex)
            if (altMedia_1 == variantIndex_1) {
              var swiperSlideIndex_1 = mediaItem_1.getAttribute(
                "data-swiper-slide-index"
              );
              inv_product_slider_1.slideTo(swiperSlideIndex_1);
            }
          });
        }
      }
    }, 7000);
  });
}
